import { BaseCommand } from './baseCommand';
import Element, { SpecyficType, ElementType } from '../element';
import store from '@/store';
import { BaseShape } from '../IShape';
import { Vector2 } from '@babylonjs/core';
import { Legs } from '../legs/legs';
import { stringUtil } from '../stringUtil';
import { ShaderNPodp } from '../shaders/legs/shader_n_podp';
import { Product, ProductType } from '@/store/modules/product';

export class HandleLegsSupportCommand extends BaseCommand {

    private previous: Element[] = [];
    private legs: Legs;

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
        this.legs = store.getters.shaders.selectedLegs;
    }

    public execute() {
        const hasSupport = this.hasSupport;
        const shouldHaveSupport = this.shouldHaveSupport;
        if (!hasSupport && !shouldHaveSupport) { return; }
        if (hasSupport && !shouldHaveSupport) {
            this.removeSupport();
        }
        if (!hasSupport && shouldHaveSupport) {
            this.addSupport();
        }
        if (
            hasSupport &&
            shouldHaveSupport &&
            this.support.model !== stringUtil.createSupportModel(this.legs)
        ) {
            this.removeSupport();
            this.addSupport();
        }
    }

    public revert() {
        this.removeElements();
        this.revertCommands();
        this.previous.forEach((x) => {
            x.isVisible = true;
            this.scenePreview.elements.push(x);
        });
    }

    private get hasSupport(): boolean {
        return this.support !== undefined;
    }

    private get shouldHaveSupport(): boolean {
        const product: Product = store.getters.product;
        if (product.type !== ProductType.CHEST_FURNITURE) { return false; }
        const body: Element = store.getters.body;
        const width = body.shape.x;
        if (store.getters.product.isLevelRaiser) { return false; }
        if (width <= 1) { return false; }
        if (width === 3 || width === 4) { return true; }
        if (width === 2) { return this.hasWallOnTheFloor; }
    }

    private get support(): Element {
        const elements: Element[] = store.getters.scene.elements;
        return elements.find((x) =>
            x.type === ElementType.LEGS &&
            x.shaderName === 'ShaderNPodp',
        );
    }

    private get hasWallOnTheFloor(): boolean {
        const elements: Element[] = store.getters.scene.elements;
        const verticalWalls = elements.filter((x) =>
            x.specyficType === SpecyficType.VERTICAL_WALL);
        const test = new BaseShape(
            new Vector2(1.5, 1),
            new Vector2(0, 1),
        );
        return verticalWalls.some((x) => test.inside(x));
    }

    private removeSupport() {
        const support = this.support;
        this.previous.push(support);
        support.isVisible = false;
        this.scenePreview.elements.splice(
            this.scenePreview.elements.indexOf(support), 1,
        );
    }

    private addSupport() {
        const model = stringUtil.createSupportModel(this.legs);
        const light = stringUtil.createSupportLight(this.legs);
        const shader = new ShaderNPodp();
        this.scenePreview.addElement(
            model,
            light,
            shader,
            Vector2.Zero(),
            Vector2.Zero(),
            (element: Element) => {
                this.elements.push(element);
            });
    }
}
